import { createApp } from "vue";
import { createPinia } from "pinia";
import { VueQueryPlugin, QueryClient } from "@tanstack/vue-query";
import { router } from "@/router";
import App from "./App.vue";
// Fonty rodziny OVB lokalnie (jak Pilot): bez Google Fonts. Fraunces tylko dla druku/portalu.
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/cormorant-garamond/300.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";
import "@fontsource/jetbrains-mono/700.css";
import "@fontsource-variable/fraunces/opsz.css";
import "@/styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin, { queryClient });
app.mount("#app");

// Hide bootloader once Vue mounted (Fix #1 — pusty ekran przy F5).
// Min 300ms żeby pokazać markę + 3 kropki — inaczej miga niewidocznie na szybkich połączeniach.
const bootloader = document.getElementById("app-bootloader");
if (bootloader) {
  const start = Number(bootloader.dataset.start ?? Date.now());
  const elapsed = Date.now() - start;
  const minVisible = 300;
  const wait = Math.max(0, minVisible - elapsed);
  setTimeout(() => {
    bootloader.classList.add("bootloader-hide");
    setTimeout(() => bootloader.remove(), 220);
  }, wait);
}
